export default __webpack_public_path__ + "static/media/psd.e7b518d0.svg";